import { useEffect, useState } from "react";
import { db } from "../Services/Database/Firebase.service";
import { collection, getDocs } from "firebase/firestore";
import { IUser } from "../Types/User/User.type";


type FecthUserState<IUser> = {
    data: IUser[] | null;
    isLoading: boolean;
    error: string | null;
}

export const useGetAllUsers = ():  FecthUserState<IUser> => {
    const [data, setData] = useState<IUser[] | null>(null); 
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(()=>{
        const GetAllUsersFromFirebase = async () => {
            setIsLoading(true);
            setError(null);

            const firestore = db;
            const usersCollectionRef = collection(firestore, 'Users');
            const usersSnapshot = await getDocs(usersCollectionRef);
            
            if(!usersSnapshot){
                return []
            }

            try {
                const usersMappedDocs: IUser[] = usersSnapshot.docs.map((doc)=>({
                    id: doc.id,
                    ...doc.data(),
                }));
                
                setData(usersMappedDocs);
            } catch (error) {
                setError((error as Error).message);
            } finally {
                setIsLoading(false);
            }
        } 
        
        GetAllUsersFromFirebase();
    }, []);

    return { data, isLoading, error};
}